var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    _vm._b(
      {
        staticClass: "svg-icon",
        style: {
          "--font-size": _vm.sizePx,
          fontSize: _vm.sizePx,
          color: _vm.color
        },
        domProps: { innerHTML: _vm._s(_vm.svgContent) }
      },
      "span",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }